import { ReactNode } from 'react';

import moment from 'moment';

import { TWeekCarousel } from '../hooks/useWeekCarousel';

import style from '../dateRangeCalendar.module.scss';

/** Соседние недели по краям ленты: их видно, пока ленту тянут пальцем */
const WEEK_OFFSETS = [-1, 0, 1];

type TProps = {
    carousel: TWeekCarousel;
    renderWeek: (weekStart: moment.Moment) => ReactNode;
};

export const WeekCarousel = ({ carousel, renderWeek }: TProps) => (
    <div className={style['grid-scroll']} {...carousel.viewportProps}>
        <div className={style['week-track']} style={carousel.trackStyle}>
            {WEEK_OFFSETS.map((offset) => {
                const weekStart = carousel.weekStart.clone().add(offset, 'week');
                return (
                    <div key={weekStart.format('YYYY-MM-DD')} className={style['week-slide']}>
                        {renderWeek(weekStart)}
                    </div>
                );
            })}
        </div>
    </div>
);
